import React from 'react';
import PropTypes from 'prop-types';

import {
  MenuList,
  MaterialIcon,
  MenuListItem,
  HOCs,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import BaseMoreButton from 'components/MoreButton';
import { ActionTypes } from 'constants/enums';
import messages from './messages';
import { Menu, MenuListItemText } from './styles';

const { enhanceWithPopper } = HOCs;
const MoreButtonWithPopper = enhanceWithPopper(BaseMoreButton);

function VersionListItemActions({ onAction, version, summary, unpublished }) {
  const onClickItem = (type) => () => {
    onAction(type, summary.pluginId, version);
  };

  const actionDelete = {
    type: ActionTypes.DELETE,
    icon: 'delete',
    message: messages.listVersionItemActionDelete,
  };

  const actionUnpublish = {
    type: ActionTypes.UNPUBLISH,
    icon: 'cloud_off',
    message: messages.listVersionItemActionUnpublish,
  };

  const actionsList = unpublished ? [actionDelete] : [actionUnpublish];

  return (
    <MoreButtonWithPopper placement="bottom-end" hidepopperonclick>
      <Menu>
        <MenuList>
          {actionsList.map((item) => (
            <MenuListItem key={item.type} onClick={onClickItem(item.type)}>
              <MaterialIcon id={item.icon} />
              <MenuListItemText>
                {intl.formatMessage(item.message)}
              </MenuListItemText>
            </MenuListItem>
          ))}
        </MenuList>
      </Menu>
    </MoreButtonWithPopper>
  );
}

VersionListItemActions.propTypes = {
  unpublished: PropTypes.bool,
  version: PropTypes.string.isRequired,
  summary: PropTypes.object.isRequired,
  onAction: PropTypes.func.isRequired,
};

export default VersionListItemActions;
